import theme from '../components/atoms/theme'

const { colours } = theme

const GetEventTypeColor = (eventType: Queries.ContentfulEventType | null) => {
  let categoryColour = colours.primary
  if (eventType) {
    switch (eventType.slug) {
      case 'event':
        categoryColour = colours.primary
        break

      case 'exhibition':
        categoryColour = colours.secondary
        break

      case 'experience':
        categoryColour = colours.experiencesCategory
        break

      default:
        break
    }
  }
  return categoryColour
}

export default GetEventTypeColor
